module.exports = __webpack_public_path__ + "img/service2.f1329457.svg";